import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./style.scss";

const EmptyState = ({withIcon, title, description}) => {
  return (
    <div style={{marginTop: "48px", paddingBottom: "48px"}}>

      {withIcon &&
          <div className="iconContainer">
            <FontAwesomeIcon
              icon={["fas", "list"]}
              style={{ fontWeight: 900, fontSize: "101px", color: "#E4EAF0" }}
            />
            <div>
              <FontAwesomeIcon
                icon={["fas", "times-circle"]}
                style={{ fontWeight: 900, fontSize: "48px", color: "#005075" }}
              />
            </div>
          </div>
      }
      <div className="messageContainer">
        <h2> {title} </h2>
        <h4>{description}</h4>
      </div>
    </div>
  );
};

export default EmptyState;